import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IAssets = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="19"
            viewBox="0 0 18 19"
            fill="none"
          >
            <path
              d="M0.899902 4.6L3.5999 1H14.3999L16.6499 4.15"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <mask id="path-2-inside-1_63_4013" fill="white">
              <rect y="3.69922" width="18" height="15.3" rx="1" />
            </mask>
            <rect
              y="3.69922"
              width="18"
              height="15.3"
              rx="1"
              stroke={props.color??"#37474F"}
              strokeWidth="3"
              mask="url(#path-2-inside-1_63_4013)"
            />
            <rect
              x="5.25"
              y="8.05078"
              width="7.5"
              height="2.1"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IAssets;
